import React from 'react';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl } from '../../_metronic/_helpers';

export function Button({ classes, logoSrc, title, formik, ...rest }) {
  return (
    <button
      className={`btn btn-primary font-weight-bold px-4 py-2 my-1 ${classes}`}
      disabled={formik ? formik.isSubmitting : false}
      {...rest}
    >
      {formik && formik.isSubmitting && (
        <span className="mr-6 px-2 spinner spinner-white"></span>
      )}
      {logoSrc ? (
        <span className="svg-icon mr-4">
          <SVG uniquifyIDs cacheRequests src={toAbsoluteUrl(logoSrc)} />
        </span>
      ) : null}
      <span>{title}</span>
    </button>
  );
}
